export default {
  loading: "로딩...",
  open: "열다",
  close: "닫기",
  stake: "베팅액",
  crdr: "승리/잃다",
  item: "한항",
  valid: "Valid",
  home_preferences: "Home Preferences",
  quick_links: "Quick Links",
  language: "언어",
  home_page: "홈페이지",
  favorites: "즐겨찾기",
  note: "주의사항",
  my_bets: "내 베팅",
  my_account: "내 계정",
  contact_us: "문의정보",
  report: "리포트",
  help_support: "도움말 및 지원",
  currency: "통화",
  others: "다른",
  welcome: "어서 오십시오",
  account_id: "계정 ID",
  password: "암호",
  account: "계정",
  all_sports: "모든 스포츠",
  my_sports: "스포츠",
  action: "동작",
  accept_better_odds: "더 나은 배당률 수락",
  accept_any_odds: "배당률 자동 새로고침",
  auto_refresh_odds: "배당률 자동 새로고침",
  auto_refresh: "자동 새로고침",
  auto_refreshing: "자동 새로고침...",
  all_markets: "모든 시장",
  available_balance: "사용 가능한 잔액",
  athletics: "육상",
  american_football: "미국 사람 축구",
  aussie_rules_football: "호주 규칙 축구",
  gmail: "Gmail",
  contact_number: "연락 번호",

  away: "원정팀",

  all: "모두",
  accepted: "받아 들여",
  add: "추가",
  add_homescreen: "홈 화면에 추가",
  abandoned: "버려진",

  bet_slip: "베팅 슬립",
  bet_credit: "베팅금액",
  bet_list: "배팅목록",
  betting: "베팅",
  balance: "잔액",

  betting_statement: "배팅 결과",
  betting_rules: "베팅 규칙",
  bet_types: "베팅의 종류",
  bs: "B/S",
  bet_summary: "베팅 서머리",
  bets: "베팅",
  basketball: "농구",
  baseball: "야구",
  badminton: "배드민턴",
  bandy: "밴디",
  boxing: "권투",
  beach_soccer: "해변 축구",

  casino: "카지노",
  cash_balance: "보유금액",
  change_account_password: "계정 암호 변경",
  current_password: "현재 비밀 번호를 확인하시기 바랍니다",
  confirm_new_password: "비밀 번호 확인",
  customize_sports_order: "스포츠 오더 사용자 정의",
  choice: "선택",
  credit: "획득",
  commission: "수수료",
  customize: "커스터마이즈",
  cancel: "취소",
  confirmation: "확인",
  continue_bet: "Continue Bet",
  customer_service: "고객 서비스 핫라인",
  cricket: "크리켓",
  cycling: "사이클링",
  copa_america: "코파 아메리카",
  combinations: "조합 방법",
  create_room: "방 만들기",

  darts: "다트",
  debit: "손실",
  display_language: "표시 언어",
  default_event_sorting: "기본 이벤트 정렬",
  default_stake: "기본 베팅금액",
  date: "날짜",
  draw: "무승부",
  draw_cancel: "무승부",
  dec: "소수점 배당률",
  double_line: "더블 라인",
  disable: "비활성화",
  dec_odds: "DEC | 소수점 배당률",
  id_odds: "IND | 인도네시아 확률",
  double_chance: "더블 찬스",
  details: "세부사항",

  enable: "가능하게하다",
  event_sorting: "이벤트 정렬",
  e_sports: "E 스포츠",
  esports2: "E 스포츠 2",
  edit: "수정하다",
  early: "초기",
  event: "경기",
  even: "짝",
  email: "이메일",
  esports: "E 스포츠",
  euro: "유로2020",
  entry_fee: "입장료",
  exclusive: "독점",

  es_101: "Map 1",
  es_102: "Map 2",
  es_103: "Map 3",
  es_104: "Map 4",
  es_105: "Map 5",
  es_106: "Map 6",
  es_107: "Map 7",
  es_108: "Map 8",
  es_109: "Map 9",
  es_110: "Map 10",
  euroDate: "12 JUNE - 12 JULY",

  fd_101: "1ST Prize",
  fd_102: "2ND Prize",
  fd_103: "3RD Prize",

  first_goal: "첫 득점",
  first_half: "전반전 득점",
  final: "최종 점수",
  full_time: "전후반경기",
  fold: "폴드",
  from: "에서",
  field_hockey: "필드하키",
  futsal: "Futsal",
  fd: "4D Special",
  fishing: "Fishing",

  gaelic_football: "게일식 축구",
  golf: "골프",
  games: "게임",
  given_credit: "기븐크레딧",
  group: "그룹",
  goal: "골",
  general: "일반 ",
  general_betting_rules: "일반 베팅 규칙",
  general_rules_market: "시장(베팅 유형) 규칙 일반 규칙",

  half_time: "전반전 경기",
  hide_header: "헤더 숨기기",
  hk: "홍콩 배당률",
  hk_odds: "HK | 홍콩 배당률",
  hdp: "핸디캡",
  home: "홈",
  hotline: "핫라인",
  handball: "핸드볼",
  hurling: "헐링",
  hour: "시",
  highlight: "하이라이트",

  id: "아이디",
  ice_hockey: "아이스하키",

  joined: "조인만 가능",
  join_now: "지금 가입",
  jackpot: "잭팟",
  
  keno: "키노",
  kickoff: "시합개시",
  kabbadi: "Kabbadi",
  kof: "King of Figthers",
  ko: "K.O By",

  lose: "잃다",
  lose_half: "반을 잃다",
  lottery: "로또",
  login: "로그인",
  logout: "로그아웃",
  last_login: "마지막 로그인",
  last_transaction: "마지막 거래",
  live_streaming: "라이브 스트리밍",
  live_match: "라이브 매치",
  live_chat: "실시간 상담",
  live: "라이브",
  live_tv: "생방송",
  livecasino: "라이브 카지노",
  loss: "손실",
  lost: "손실",
  last_bet: "마지막 베팅",
  last_goal: "마지막 득점",
  leave_room: "방 나가기",
  last_betting_time: "마지막 베팅 시간",
  lose_all: "모두 잃음",

  mobile: "움직이기 쉬운",
  message: "메시지",
  my_bet: "내 베팅",
  my_favorites: "즐겨찾기",
  market_type: "마켓 유형",
  match: "경기",
  message_history: "메시지 히스토리",
  my: "MY",
  market: "시장",
  main_markets: "주요 시장",
  my_odds: "MY | 말레이 배당률",
  min: "최저",
  max: "최대 베팅 금액",
  max_payout: "최대 페이아웃",
  main: "주요 시장",
  corners: "코너킥/경고,퇴장",
  specials: "스페셜",
  mix_parlay: "믹스 팔레이",
  mma: "종합 격투기",
  motorsports: "모토스포츠",
  muay_thai: "무에 타이",
  map1: "Map 1",
  map2: "Map 2",
  map3: "Map 3",
  map4: "Map 4",
  map5: "Map 5",
  map6: "Map 6",
  map7: "Map 7",
  map8: "Map 8",
  map9: "Map 9",
  matches: "경기",
  mini_arcade: "Mini Arcade",
  match_started: "-",

  no_goal: "노 골",
  normal_announcements: "일반 공지 사항",
  nickname: "닉네임",
  new_password: "새 비밀번호",
  new: "뉴",
  "no/": "숫자.",
  normal_sorting: "일반 분류",
  netball: "네트볼",
  newsinfo: "뉴스 & 정보",
  next: "다음",

  olympic: "올림픽",
  other_markets: "기타 마켓",
  outstanding: "베팅중인 내역",
  odds_type: "배당률 종류",
  odds: "배당률",
  opening_balance: "기초 잔액",
  outright: "승자 예상 배팅",
  oe: "홀수/짝수",
  on: "켜짐",
  off: "꺼짐",
  outstanding_bet: "뛰어난 내기",
  over: "오버",
  odd: "홀수",
  official_link: "외부 링크",
  owner: "룸 소유자",

  password_expiry: "비밀번호 만료일",
  parlay: "팔레이",
  parlay_early: "팔레이 초기",
  mmo_parlay: "미얀마 팔레이",
  mmo_odds: "미얀마 확률",
  page_display: "페이지 표시",
  page_type: "페이지 유형",
  page_size: "페이지 크기",
  personal_message: "개인 공지사항",
  process_bet: "베팅하다",
  payout: "지불 금액",
  pending: "보류",
  personal: "개인",
  play_now: "지금 플레이",
  parlay_generator: "Parlay Generator",
  private: "비공개",
  pool: "지불 금액 $",
  players: "선수",
  points: "포인트",
  prize: "상",
  play_to_earn: "Play to Earn",
  
  quick_bet: "빠른 베팅",
  qq: "QQ",

  room: "방",
  result: "결과보기",
  restore: "복원하기",
  remark: "결과",
  ref_no: "참조 번호.",
  remove_from_parlay: "Remove From Parlay",
  running: "진행 중",
  reject: "무효",
  rugby: "럭비",
  roundof16: "Rounds of 16",
  quater_finals: "Quater Finals",
  semi_finals: "Semi Finals",
  room_id: "방 ID",
  refund: "환불",

  skype: "Skype",
  sports: "스포츠",
  show_balance: "밸런스 표시",
  statement: "거래내역서",
  settings: "설정",
  search_team: "팀 검색",
  show_header: "헤더 표시",
  submit: "제출하다",
  set_nickname: "닉네임 설정",
  single: "싱글",
  save: "저장",
  show_score_map: "스코어 맵 표시",
  status: "지위",
  sort: "활자 한 벌",
  sportsbook: "스포츠북",
  sum: "SUM",
  special_announcements: "특별 공지 사항",
  subtotal: "소계",
  single_line: "싱글 라인",
  sort_by_time: "시간으로 분류",
  slots: "슬롯",
  select_leagues: "리그 선택",
  special: "스페셜",
  scroll_bottom: "베팅 영역으로 스크롤하려면 누릅니다",
  swipe_to_search: "스 와이프하여 검색",
  soccer: "축구",
  squash: "스쿼시",
  sepak_takraw: "Sepak Takraw",
  snooker: "포켓볼/당구",
  suite_sa: "SA Gaming",
  suite_gp: "Game Play",
  suite_evo: "Evolution",
  suite_ct855: "CT855",
  suite_bg: "Macau Suite",
  suite_pg: "Pretty Gaming",
  suite_yb: "Yeebet",
  "suite_pp-c": "Pragmatic",
  suite_ai: "AI Casino",
  sfv_101: "Round 1",
  sfv_102: "Round 2",
  sfv_103: "Round 3",
  sfv_104: "Round 4",
  sfv_105: "Round 5",
  settlement: "정착",
  settled_amount: "정산 금액",
  settled: "안정된",
  search: "검색",
  sysparlay: "개의 팔레이",
  stake_per_bet: "Stake Per Bet",
  score: "점수",
  winner: "우승자",
  slot_live22: "Live22",
  slot_pgs: "PGSoft",
  slot_ppg: "Pramagtic Play",
  slot_jkr: "Joker",
  slot_spp: "Simple Play",
  slot_jili: "Jili",
  slot_uusl: "UUSlot",
  slot_next: "Nextspin",
  slot_dbhash: "DB Hash",
  slot_wow: "WOW Gaming",
  slot_wf: "WF Gaming",
  selected: "선택됨",
  select_matches: "매치 선택",

  turnover: "총배팅액",
  today: "오늘",
  time: "시각",
  team: "팀",
  to: "에",
  trans_time: "배팅 시간",
  total: "전체",
  total_goal: "총 득점",
  treble: "3배",
  total_bets: "총 베팅하는 금액",
  tnc: "일반 약관",
  tennis: "테니스",
  table_tennis: "탁구",
  telegram: "telegram",
  total_stake: "총 지분",
  tournament: "토너먼트",
  tomorrow: "내일",
  total_points: "총 점수",
  tournament_refund: "토너먼트 환불",

  under: "언더",
  void: "무효로",
  volleyball: "배구",
  void_list: "무효로 명부",
  view_odds: "배당률보기",
  video: "비디오",

  won_all: "모두 이겼습니다",
  won_half: "원 하프",
  win_half: "절반승리",
  win: "승리",
  won: "승리",
  waiting: "대기중",
  wechat: "Wechat",
  whatsapp: "Whatsapp",
  winter_sports: "동계 스포츠",
  water_polo: "수구",
  winlose: "승리/잃다",
  winner_rank: "승자 순위",

  yes: "예",
  no: "아니",

  yesterday: "어제",
  monday: "월요일",
  tuesday: "화요일",
  wednesday: "수요일",
  thursday: "목요일",
  friday: "금요일",
  saturday: "토요일",
  sunday: "일요일",

  all_league: "모든 리그",
  match_completed: "종료",
  match_pending: "결과 보류",
  match_cancelled: "환불",
  match_cancelled_1h: "환불 1H",
  match_cancelled_2h: "환불 2H",
  match_suspended: "Abandoned",
  match_suspended_1h: "Abandoned 1H",
  match_suspended_2h: "Abandoned 2H",

  check_all: "모두 체크하기",
  selected_only: "선택 항목만",
  filtered: "거르는",
  turn_on: "켜짐",
  turn_off: "꺼짐",

  more_bet_types: "더 많은 내기 유형",
  switch_to_desktop: "데스크탑으로 전환",

  events: "경기",
  brackets: "브라켓",
  standing: "서 있는",

  big_small: "큰/작은",
  odd_even: "홀수/짝수",

  first_digit: "1 자리",
  second_digit: "2 자리",
  third_digit: "3 자리",
  forth_digit: "4 자리",
  total_4d: "Total 4D",
  total_3d: "Total of Last 3D",
  total_1st2d: "Total 1st 2D",
  total_last2d: "Total Last 2D",
  total_winlose: "전체 승리/잃다",

  news: "뉴스",
  more: "더",
  settled_remark: "참고: 오늘 시장의 베팅이 표시되고 정산된 경기의 티켓이 명세서로 이동됩니다.",
  w4d: "4D",
  deselect_all : "모두 선택 취소",
  select_all : "모두 선택",
  done: "끝난",
  tutorial_tooltips: "홈 화면에이 앱을 설치하는 방법",
  tutorial: "튜토리얼",
  dismiss: "취소",
  seven_days: "지난 7 일",
  fourteen_days: "지난 14 일",

  hide: "숨기기",
  more_details: "자세한 내용",
  goto_statement: "명세서로 이동",
  transfer: "송금",
  no_record: "기록을 찾을 수 없습니다",
  no_bet: "내기 없음",

  random_pick: "생성하다",
  add_pick: "베팅 전표에 추가",

  worldcup: "WORLD CUP 2022",
  time_remaining: "남은 시간",

  slot_championstar: "Champion Star",
  slot_fifafiesta: "Fifa Fiesta",
  slot_penaltymania: "Penalty Mania",
  minigame_dragon: "Dragon's Treasure",
  minigame_illuvium: "Illuvium Master",
  minigame_mobo: "Mobox Olympia",

  egames: "V-Games",
  feedback: "사용자 피드백",
  ranking: "순위",
  total_winning: "총 승리",
  first_prize: "1등 상",
  second_prize: "2등 상",
  third_prize: "3등 상",
  place: "순위",
  current_point: "현재 포인트",
  free_room: "무료 객실",
  last_join_time: "최종 가입 시간",
  archery: "양궁",
  winter_olympic: "동계 올림픽",
  no1: "1위 우승자",
  adjustment: "조정",
  poker: "포커",
  poker_db: "DB Poker"
};
